module.exports = __webpack_public_path__ + "img/globe-fill.e3dcead9.svg";